export default class CreateCampaignContactsRequest {
    contactIds: string[] = [];    
}
